// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import iterator from 'dom-iterator'

export function createSelectionRange(el: HTMLElement, selection: { start: number; end: number }) {
  const start = selection.start
  const end = selection.end

  const range = document.createRange()

  const i = iterator(el.firstChild, el)

  let next = i.node
  let isClosing = false

  let count = 0
  let length

  while (next) {
    if (count === start) {
      if (isClosing) {
        range.setStartAfter(next)
      } else {
        range.setStartBefore(next)
      }
    }

    if (count === end) {
      if (isClosing) {
        range.setEndAfter(next)
      } else {
        range.setEndBefore(next)
      }

      return range
    }

    if (!isClosing) {
      if (isBr(next) || (next.previousSibling && (isDiv(next) || isParagraph(next)))) {
        count++
      }
    }

    if (isText(next)) {
      length = next.textContent.length

      if (count <= start && count + length > start) {
        range.setStart(next, start - count)
      }

      if (count + length > end) {
        range.setEnd(next, end - count)

        return range
      }

      count += length
    }

    next = i.next()
    isClosing = i.closingTag
  }

  // out of range
  if (count <= start) {
    if (el.lastChild) {
      range.setStartAfter(el.lastChild)
    } else {
      range.setStart(el, 0)
    }
  }

  if (el.lastChild) {
    range.setEndAfter(el.lastChild)
  } else {
    range.setEnd(el, 0)
  }

  return range
}

function isText(node: Node) {
  return node.nodeType === 3
}

function isBr(node: Node) {
  return node.nodeType === 1 && node.nodeName === 'BR'
}

function isDiv(node: Node) {
  return node.nodeType === 1 && node.nodeName === 'DIV'
}

function isParagraph(node: Node) {
  return node.nodeType === 1 && node.nodeName === 'P'
}
